// CenterBrand.jsx
import { NavLink } from "react-router-dom";
import { Box } from "@mui/material";
import Logo from "../../../assets/logo.png";
export default function CenterBrand({ onClick, light = false }) {
  return (
    <Box
      component={NavLink}
      to="/"
      onClick={onClick}
      sx={{
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        display: "flex",
        alignItems: "center",
        gap: 1,
        textDecoration: "none",
        color: "inherit",
        py: 0.5,
        px: 1,
        transition: "filter .25s ease, transform .25s ease",
        "&:hover": { transform: "translate(-50%, -50%) scale(1.03)" },
      }}
      aria-label="Gå till startsidan"
    >
      <Box
        component="img"
        src={Logo}
        alt="CreativeInsights"
        className="nav-logo"
        sx={{
          height: { xs: 32, md: 40 },
          width: "auto",
          display: "block",
          filter: light
            ? "brightness(0) invert(1) drop-shadow(0 2px 8px rgba(0,0,0,0.35))"
            : "none",
          transition: "filter .25s ease",
        }}
      />
    </Box>
  );
}
